import type { ReactNode } from 'react';
import type { MountErrorCode } from '@frameio/graphql-client/generated/types';
import { select } from '@frameio/i18n';
import TEXT from './generated/TEXT/useMountErrorMessage';

TEXT.DEFINE({
  // Reason that a user is unable to mount a project, displayed in tooltips and dialogs
  cannotMountReason: (reason?: MountErrorCode) =>
    select(reason ?? 'other', {
      ACCOUNT_LOCKED: 'Account is locked.',
      ACCOUNT_DELINQUENT: 'Account is delinquent.',
      NO_MOUNTED_STORAGE_ENTITLEMENT:
        'Mounted Storage is not included in your current plan.',
      MOUNTED_STORAGE_DISABLED:
        'An administrator has disabled the Mounted Storage feature on this account.',
      CONTENT_SECURITY_RESTRICTION:
        'Mounted Storage is not available in this workspace because one or more content security features, such as watermarking, have been enabled.',
      STORAGE_QUOTA_EXCEEDED:
        'Not enough Mounted Storage. Ask an admin to try moving some projects to Standard Storage to free up space.',
      PROJECT_LOCKED:
        'This project can’t be opened on desktop. Admins can allow mounting with Frame.io Drive in Settings.',
      INSUFFICIENT_PERMISSIONS:
        'You do not have permission to mount this project.',
      other: 'You do not have permission to mount this project.',
    }),
});

export function useMountErrorMessage(error?: MountErrorCode): ReactNode {
  return TEXT.cannotMountReason(error);
}
